import React from 'react'
import createIcon from '../createSvgIcon'

const path = (
    /* eslint-disable max-len */
    <g>
        <path
            fill='#46b549'
            d='M28.507 2.742a11.686 11.686 0 0 1-3.359.92A5.86 5.86 0 0 0 27.719.427a11.68 11.68 0 0 1-3.713 1.42A5.843 5.843 0 0 0 19.737 0a5.848 5.848 0 0 0-5.698 7.18A16.6 16.6 0 0 1 1.985 1.07a5.815 5.815 0 0 0-.792 2.94 5.844 5.844 0 0 0 2.602 4.867 5.818 5.818 0 0 1-2.649-.732l-.001.074a5.852 5.852 0 0 0 4.692 5.734 5.889 5.889 0 0 1-2.642.1 5.857 5.857 0 0 0 5.464 4.061 11.74 11.74 0 0 1-7.264 2.503c-.472 0-.937-.028-1.395-.082a16.557 16.557 0 0 0 8.965 2.627c10.758 0 16.641-8.91 16.641-16.637 0-.254-.006-.506-.017-.757a11.892 11.892 0 0 0 2.918-3.026z'/>
    </g>

    /* eslint-enable */
);
const Twitter = createIcon(path, {
    width: 29,
    height: 24,
    viewBox: '0 0 29 24'
})

export default Twitter
